/* Shade Studios — Finder (Suche 2.0)
 * Versteht freie Eingaben wie „43 sofort jordan 4 reimagined max 200 €“, setzt daraus
 * Größe / Sofort / Preis / Stichwörter und prüft die Treffer VARIANTENGENAU nach.
 * Kein Backend, kein Token: URL-Parameter + Daten, die das Theme je Karte mitliefert.
 *
 * URL-Vertrag (Suche):
 *   q    = strenge Suche  (vendor:"x" title:a title:b)  – Shopify-AND über Felder
 *   fq   = freier Text so, wie der Kunde ihn meint (nur Stichwörter)
 *   gr   = Größen, kommagetrennt (43,43.5,M)
 *   sofort=1 · pmin · pmax
 *   fb=1 = Rückfall: keine exakte Übereinstimmung, ähnliche Treffer
 */
(function (root) {
  'use strict';

  var SOFORT_SUFFIX = /\s*-\s*sofort verf[uü]gbar!?/i;
  var LIEFER_SUFFIX = /\s*-\s*lieferzeit[^|]*$/i;

  /* Größen-Gruppen der Search&Discovery (nur Vorfilter; exakt prüft das JS). */
  var GRP = 'gid://shopify/FilterSettingGroup/';
  var SIZE_GROUPS = {"XS": "XS", "S": "gid://shopify/FilterSettingGroup/245498123", "M": "gid://shopify/FilterSettingGroup/245530891", "L": "gid://shopify/FilterSettingGroup/245563659", "XL": "gid://shopify/FilterSettingGroup/245596427", "XXL": "gid://shopify/FilterSettingGroup/245629195", "35 EU": "gid://shopify/FilterSettingGroup/114327819", "35.5 EU": "gid://shopify/FilterSettingGroup/114360587", "36 EU": "gid://shopify/FilterSettingGroup/114393355", "36.5 EU": "gid://shopify/FilterSettingGroup/114426123", "37 EU": "gid://shopify/FilterSettingGroup/114458891", "38 EU": "gid://shopify/FilterSettingGroup/114491659", "38.5 EU": "gid://shopify/FilterSettingGroup/114524427", "39 EU": "gid://shopify/FilterSettingGroup/114557195", "40 EU": "gid://shopify/FilterSettingGroup/114589963", "40.5 EU": "gid://shopify/FilterSettingGroup/114622731", "41 EU": "gid://shopify/FilterSettingGroup/114655499", "42 EU": "gid://shopify/FilterSettingGroup/114688267", "42.5 EU": "gid://shopify/FilterSettingGroup/114721035", "43 EU": "gid://shopify/FilterSettingGroup/114753803", "44 EU": "gid://shopify/FilterSettingGroup/114786571", "44.5 EU": "gid://shopify/FilterSettingGroup/114819339", "45 EU": "gid://shopify/FilterSettingGroup/114852107", "45.5 EU": "gid://shopify/FilterSettingGroup/114884875", "46 EU": "gid://shopify/FilterSettingGroup/114917643", "46.5 EU": "gid://shopify/FilterSettingGroup/114950411", "47 EU": "gid://shopify/FilterSettingGroup/114983179", "47.5 EU": "gid://shopify/FilterSettingGroup/115015947", "48 EU": "gid://shopify/FilterSettingGroup/115048715", "48.5 EU": "gid://shopify/FilterSettingGroup/115081483", "49.5 EU": "gid://shopify/FilterSettingGroup/245661963", "50.5 EU": "gid://shopify/FilterSettingGroup/245694731", "OS": "gid://shopify/FilterSettingGroup/245760267"};

  var COLORS = {
    'schwarz': 'black', 'weiß': 'white', 'weiss': 'white', 'grau': 'grey', 'braun': 'brown',
    'rot': 'red', 'blau': 'blue', 'grün': 'green', 'gruen': 'green', 'gelb': 'yellow',
    'rosa': 'pink', 'lila': 'purple', 'violett': 'purple', 'orange': 'orange', 'creme': 'cream',
    'silber': 'silver', 'gold': 'gold', 'marine': 'navy', 'dunkelblau': 'navy', 'hellblau': 'blue'
  };
  var ALIASES = {
    'af1': 'air force 1', 'af 1': 'air force 1', 'aj1': 'jordan 1', 'aj2': 'jordan 2', 'aj3': 'jordan 3',
    'aj4': 'jordan 4', 'aj5': 'jordan 5', 'aj6': 'jordan 6', 'aj11': 'jordan 11', 'aj12': 'jordan 12', 'aj13': 'jordan 13',
    'tn': 'air max plus', 'dunks': 'dunk', 'yzy': 'yeezy', 'nb': 'new balance', 'travis': 'travis scott',
    'trav': 'travis scott', 'sambas': 'samba', 'gazelles': 'gazelle', 'jordans': 'jordan', 'airmax': 'air max',
    'jordan1': 'jordan 1', 'jordan4': 'jordan 4', 'am90': 'air max 90', 'am1': 'air max 1', 'am95': 'air max 95',
    'am97': 'air max 97'
  };
  var STOP = {};
  ('in im mit und für fuer von der die das den dem ein eine zu nach suche suchen ich brauche habt gibt es bitte ' +
    'gerne oder auch noch bei größe grösse groesse gr size eu schuhe schuh sneaker sneakers preis euro eur ' +
    'maximal bis ab unter über ueber höchstens hoechstens budget für herren herr men damen frauen under below women').split(' ')
    .forEach(function (w) { STOP[w] = 1; });

  /* Marken, bei denen der Titel die Marke oft NICHT enthält → vendor:-Feld. */
  var VENDORS = [
    ['new balance', 'New Balance'], ['pop mart', 'Pop Mart'], ['denim tears', 'Denim Tears'],
    ['vale forever', 'Vale Forever'], ['onitsuka tiger', 'Onitsuka Tiger'], ['under armour', 'Under Armour'],
    ['nike', 'Nike'], ['adidas', 'Adidas'], ['asics', 'ASICS'], ['puma', 'Puma'], ['ugg', 'UGG'],
    ['salomon', 'Salomon'], ['supreme', 'Supreme'], ['crocs', 'Crocs'], ['vans', 'Vans'],
    ['converse', 'Converse'], ['saucony', 'Saucony'], ['hoka', 'Hoka'], ['birkenstock', 'Birkenstock'],
    ['timberland', 'Timberland'], ['stussy', 'Stussy'], ['stüssy', 'Stussy'], ['reebok', 'Reebok']
  ];
  var CLOTHES = { xxs: 'XXS', xs: 'XS', s: 'S', m: 'M', l: 'L', xl: 'XL', xxl: 'XXL', xxxl: 'XXXL', '2xl': 'XXL', '3xl': 'XXXL' };
  var MODEL_GUARD = /(?:^|\s)(?:jordan|aj|kobe|lebron|kd|kyrie|zoom)\s*$/;

  function num(s) { return parseFloat(String(s).replace(',', '.')); }
  function fmtSize(n) { return (Math.round(n * 100) / 100).toString(); }

  /** Alle Größen zwischen a und b (Schritt 1/3, 1/2) als Textwerte. */
  function expandRange(a, b) {
    var out = [], i;
    var lo = Math.min(a, b), hi = Math.max(a, b);
    var steps = [0, 1 / 3, 0.5, 2 / 3];
    for (i = Math.floor(lo); i <= Math.ceil(hi); i++) {
      steps.forEach(function (st) {
        var v = i + st;
        if (v >= lo - 1e-9 && v <= hi + 1e-9) out.push(fmtSize(v));
      });
    }
    return out;
  }

  /** Eine freie Eingabe → strukturierte Bedeutung. */
  function parse(input) {
    var s = ' ' + String(input || '').toLowerCase().replace(/\s+/g, ' ') + ' ';
    var r = { sizes: [], clothes: [], sofort: false, pmin: null, pmax: null, words: [], vendor: '', colors: [], sku: '' };
    function cut(re, fn) {
      s = s.replace(re, function () { var a = arguments; var ret = fn.apply(null, a); return ret === undefined ? ' ' : ret; });
    }

    // Modellnamen schützen („air max 90“, „max 1“ sind keine Preise)
    s = s.replace(/\bair max\b/g, 'airmax');
    s = s.replace(/\bmax\s*(?=(?:1|90|95|97|98|180|270|720|plus|dn|aura|scorpion)\b)/g, 'airmax ');

    // Preis ------------------------------------------------------------------
    cut(/(\d{2,4})\s*(?:-|–|bis|to)\s*(\d{2,4})\s*(?:€|eur\b|euro\b)/g, function (m, a, b) {
      r.pmin = Math.min(+a, +b); r.pmax = Math.max(+a, +b);
    });
    cut(/(?:\bmax(?:imal)?\.?|\bbis|\bunter|\bunder|\bbelow|\bup to|höchstens|hoechstens|<=?|≤|nicht mehr als|budget(?: von)?)\s*(\d{2,4})(?:[.,]\d+)?\s*(€|eur\b|euro\b)?/g,
      function (m, a, cur) {
        var n = +a;
        // „bis 44“ ohne Währung ist eine Größe, kein Preis
        if (!cur && n >= 30 && n <= 52) return m;
        r.pmax = n;
      });
    cut(/(?:\bab\b|\bmin(?:destens)?\.?|\büber\b|\bueber\b|\bfrom\b|\bover\b|mehr als|more than|>=?|≥)\s*(\d{2,4})(?:[.,]\d+)?\s*(€|eur\b|euro\b)?/g, function (m, a, cur) {
      var n = +a;
      if (!cur && n >= 30 && n <= 52) return m;
      r.pmin = n;
    });
    cut(/(\d{2,4})(?:[.,]\d+)?\s*(?:€|eur\b|euro\b)/g, function (m, a) { if (r.pmax == null) r.pmax = +a; });
    cut(/€\s*(\d{2,4})/g, function (m, a) { if (r.pmax == null) r.pmax = +a; });

    // Sofort -------------------------------------------------------------------
    cut(/\b(?:sofort(?:\s*|-)?(?:verf[uü]gbar|lieferbar|versand)?|sofortlieferbar|auf lager|lagernd|express|am lager|in stock|instock|ready to ship)\b/g,
      function () { r.sofort = true; });

    // Größen -------------------------------------------------------------------
    // Bruch: „43 1/3“
    cut(/\b(3\d|4\d|50)\s+([12])\s*\/\s*3\b/g, function (m, a, b) { r.sizes.push(fmtSize(+a + (+b) / 3)); });
    // Bereich: „43 bis 44“, „43-44“, „43/44“, „43 oder 44“, „43,44“
    cut(/\b(3\d(?:[.,]\d)?|4\d(?:[.,]\d)?|50)\s*(?:bis|-|–|\/|oder|und|&|to)\s*(3\d(?:[.,]\d)?|4\d(?:[.,]\d)?|50)\b/g,
      function (m, a, b) {
        var x = num(a), y = num(b);
        if (y >= x && y - x <= 4) expandRange(x, y).forEach(function (v) { r.sizes.push(v); });
        else { r.sizes.push(fmtSize(x)); r.sizes.push(fmtSize(y)); }
      });
    // Marker: „größe 43“, „gr. 43,5“, „eu 43“, „43 eu“, „size 43“
    cut(/(?:gr(?:ö|oe)(?:ß|ss)e|gr\.?|size|eu|schuhgr(?:ö|oe)(?:ß|ss)e)\s*:?\s*(3\d(?:[.,]\d)?|4\d(?:[.,]\d)?|50)\b/g,
      function (m, a) { r.sizes.push(fmtSize(num(a))); });
    cut(/\b(3\d(?:[.,]\d)?|4\d(?:[.,]\d)?|50)\s*eu\b/g, function (m, a) { r.sizes.push(fmtSize(num(a))); });
    // Einzelzahl 33–50 (nicht Teil eines SKU-/Modellworts, nicht „jordan 38“)
    s = s.replace(/(^|\s)(3[3-9]|4\d|50)(?:[.,]5)?(?=\s)/g, function (m, pre, n, off) {
      var before = s.slice(0, off + pre.length);
      var full = m.trim();
      if (MODEL_GUARD.test(before) && +n >= 36 && +n <= 40) return m;
      r.sizes.push(fmtSize(num(full)));
      return pre;
    });

    // Bekleidung: einzelnes Token s/m/l/xl/xxl
    var left = s.trim().split(/\s+/).filter(Boolean);
    var rest = [];
    left.forEach(function (t) {
      var clean = t.replace(/[.,;:!?]+$/g, '');
      if (CLOTHES[clean] && left.length > 1 || (CLOTHES[clean] && /^(xs|xl|xxl|xxxl|2xl|3xl)$/.test(clean))) {
        r.clothes.push(CLOTHES[clean]);
      } else rest.push(clean);
    });
    if (rest.length === 0 && left.length === 1 && CLOTHES[left[0]]) { r.clothes.push(CLOTHES[left[0]]); }

    // Wörter -------------------------------------------------------------------
    var text = rest.join(' ').replace(/airmax/g, 'air max');
    Object.keys(ALIASES).sort(function (a, b) { return b.length - a.length; }).forEach(function (k) {
      text = text.replace(new RegExp('(^|\\s)' + k.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + '(?=\\s|$)', 'g'), '$1' + ALIASES[k]);
    });
    // Marke (mehrteilig zuerst)
    for (var i = 0; i < VENDORS.length; i++) {
      var k2 = VENDORS[i][0];
      var re = new RegExp('(^|\\s)' + k2 + '(?=\\s|$)');
      if (re.test(text)) { r.vendor = VENDORS[i][1]; text = text.replace(re, ' '); break; }
    }
    var words = [];
    text.split(/\s+/).forEach(function (w) {
      if (!w || STOP[w]) return;
      if (COLORS[w]) { r.colors.push(w); words.push(COLORS[w]); return; }
      words.push(w);
    });
    // SKU erkannt (z. B. DZ5485-612, IB4171-100)
    words.forEach(function (w) { if (/^[a-z]{1,3}\d{3,5}-\d{3}$/i.test(w)) r.sku = w.toUpperCase(); });
    r.words = words;
    // Duplikate raus
    r.sizes = r.sizes.filter(function (v, i2, a) { return a.indexOf(v) === i2; });
    r.clothes = r.clothes.filter(function (v, i2, a) { return a.indexOf(v) === i2; });
    return r;
  }

  /** Strenge Shopify-Suche: AND über Titel-Wörter, Marke im Marken-Feld. */
  function strictQuery(p) {
    if (p.sku) return p.sku;
    /* Einzelne Nummer mit Buchstabe (163862C, 2002R): Titel ODER Varianten-SKU */
    if (!p.vendor && p.words.length === 1 && /^(?=[a-z0-9]*\d{4})(?=[a-z0-9]*[a-z])[a-z0-9]{5,}$/i.test(p.words[0]))
      return 'title:' + p.words[0] + ' OR variants.sku:' + p.words[0].toUpperCase();
    var parts = [];
    /* Marke im Hersteller-Feld ODER im Titel (Nike x Supreme: Hersteller Nike, „Supreme“ nur im Titel) */
    if (p.vendor) parts.push('(vendor:"' + p.vendor + '" OR title:"' + p.vendor.toLowerCase() + '")');
    p.words.forEach(function (w) {
      if (/^[\wäöüß.\-+]+$/i.test(w)) parts.push('title:' + w);
    });
    return parts.join(' ');
  }
  function looseQuery(p) {
    return (p.vendor ? p.vendor + ' ' : '') + p.words.join(' ');
  }

  function sizeGroupsFor(p) {
    var out = [], seen = {};
    p.sizes.forEach(function (sz) {
      var base = String(Math.floor(num(sz)));
      var key = (sz.indexOf('.') > -1 ? sz : base) + ' EU';
      var g = SIZE_GROUPS[key] || SIZE_GROUPS[base + ' EU'];
      if (g && !seen[g]) { seen[g] = 1; out.push(g); }
    });
    p.clothes.forEach(function (c) { var g = SIZE_GROUPS[c]; if (g && !seen[g]) { seen[g] = 1; out.push(g); } });
    return out;
  }

  /** Zustand ⇄ URL */
  function toUrl(st, base) {
    var u = [];
    var p = st.parsed;
    var q = st.fallback ? looseQuery(p) : strictQuery(p);
    u.push('type=product');
    u.push('q=' + encodeURIComponent(q || '*'));
    var fq = (p.vendor ? p.vendor + ' ' : '') + p.words.join(' ');
    if (fq.trim()) u.push('fq=' + encodeURIComponent(fq.trim()));
    if (p.sofort) u.push('sofort=1');
    if (p.pmin != null) u.push('filter.v.price.gte=' + p.pmin);
    if (p.pmax != null) u.push('filter.v.price.lte=' + p.pmax);
    if (!st.noGroups) {
      sizeGroupsFor(p).forEach(function (g) { u.push('filter.v.option.' + encodeURIComponent('größe') + '=' + encodeURIComponent(g)); });
    }
    if (st.fallback) u.push('fb=1');
    if (st.sort) u.push('sort_by=' + encodeURIComponent(st.sort));
    (st.extra || []).forEach(function (kv) { u.push(kv); });
    /* AUDIT C3 27.10.2026: Suche in der aktuellen Sprache (/en/search statt /search) */
    return (base || ((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/') + 'search') + '?' + u.join('&');
  }

  function fromLocation(loc) {
    var sp = new URLSearchParams(loc.search);
    var p = { sizes: [], clothes: [], sofort: false, pmin: null, pmax: null, words: [], vendor: '', colors: [], sku: '' };
    var fq = sp.get('fq') || '';
    var q = sp.get('q') || '';
    var fromFq = parse(fq);
    p.words = fromFq.words; p.vendor = fromFq.vendor; p.sku = fromFq.sku;
    if (!fq && q && q !== '*') {
      // nackte Eingabe (z. B. ohne Finder): trotzdem verstehen
      var f2 = parse(q.replace(/title:|vendor:|"/g, ' '));
      p = f2;
    }
    // Größen kommen aus den ECHTEN Shopify-Filterwerten (Gruppen-IDs) → Rückübersetzung
    var rev = {};
    Object.keys(SIZE_GROUPS).forEach(function (k) { rev[SIZE_GROUPS[k]] = k; });
    sp.getAll('filter.v.option.größe').forEach(function (g) {
      var lab = rev[g] || g;
      if (!rev[g] && typeof document !== 'undefined') {   // Gruppen ohne Eintrag (z. B. adidas „43 1/3“): Beschriftung der Kachel verwenden
        var inp = null;
        Array.prototype.forEach.call(document.querySelectorAll('.finder-tile__input'), function (i) { if (i.value === g) inp = i; });
        var bx = inp && inp.parentNode.querySelector('.finder-tile__box');
        if (bx) lab = bx.getAttribute('data-raw') || bx.textContent;
      }
      if (!rev[g]) lab = sizeKey(lab);   // alte Direktlinks: „L/XL - Sofort verfügbar!“ → „L/XL“
      if (CLOTHES[lab.toLowerCase()] || /^(OS)$/.test(lab)) p.clothes.push(lab.toUpperCase());
      else if (/^\d{2}(?:\.\d+)?(?:\s*EU)?$/i.test(lab)) { var n = lab.replace(/\s*EU\s*$/i, '').trim(); if (n) p.sizes.push(n); }
      else if (lab) p.clothes.push(String(lab).toUpperCase());   // L/XL, S/M … gelten wie Buchstabengrößen
    });
    p.farbe = sp.getAll('farbe'); p.kat = sp.getAll('kat'); p.modell = sp.getAll('modell');
    if (sp.get('sofort') === '1') p.sofort = true;
    if (sp.get('filter.v.price.gte')) p.pmin = +sp.get('filter.v.price.gte');
    if (sp.get('filter.v.price.lte')) p.pmax = +sp.get('filter.v.price.lte');
    return { parsed: p, fallback: sp.get('fb') === '1', sort: sp.get('sort_by') || '' };
  }

  /** Varianten-Prüfung: Daten je Karte „Größe~Preis~verfügbar~id|…“ */
  function sizeKey(raw) {
    var v = String(raw || '').replace(SOFORT_SUFFIX, '').replace(LIEFER_SUFFIX, '').replace(/\s*EU\s*$/i, '').trim();
    var m = v.match(/^(\d{2})\s+([12])\s*\/\s*3$/);
    if (m) return fmtSize(+m[1] + (+m[2]) / 3);
    if (/^\d{2}(?:[.,]\d)?$/.test(v)) return fmtSize(num(v));
    v = v.toUpperCase().replace(/\s*-\s*SOFORT.*$/i, '').trim();
    if (/^(ONE\s*SIZE|ONESIZE|O\/S|OS)$/.test(v)) return 'OS';
    return v;
  }
  function parseVariants(data) {
    return String(data || '').split('|').filter(Boolean).map(function (x) {
      var a = x.split('~');
      var raw = a[0];
      return {
        raw: raw, key: sizeKey(raw), price: (+a[1]) / 100, avail: a[2] === '1', id: a[3],
        sofort: SOFORT_SUFFIX.test(raw), liefer: LIEFER_SUFFIX.test(raw)
      };
    });
  }
  function bestMatch(variants, p) {
    var hits = variants.filter(function (v) {
      if (!v.avail) return false;
      if (p.sofort && !v.sofort) return false;
      if ((p.sizes.length || p.clothes.length)) {
        var ok = p.sizes.indexOf(v.key) > -1 || p.clothes.indexOf(v.key) > -1;   // 43 1/3 ist eine eigene Größe
        if (!ok) return false;
      }
      if (p.pmin != null && v.price < p.pmin) return false;
      if (p.pmax != null && v.price > p.pmax) return false;
      return true;
    });
    hits.sort(function (a, b) { return (b.sofort - a.sofort) || (a.price - b.price); });
    return hits;
  }

  /** Produkt-Ebene (Farbe/Kategorie/Modell) aus data-Attributen der Karte */
  function productMatches(d, p) {
    function any(list, val) {
      if (!list || !list.length) return true;
      var have = String(val || '').split('|').filter(Boolean);
      return list.some(function (x) { return have.indexOf(x) > -1; });
    }
    return any(p.farbe, d.color) && any(p.modell, d.model);
  }

  var api = {
    productMatches: productMatches,
    parse: parse, strictQuery: strictQuery, looseQuery: looseQuery, toUrl: toUrl, fromLocation: fromLocation,
    fmtLabel: function (k) { k = String(k); var m = k.match(/^(\d+)\.33$/); if (m) return m[1] + ' 1/3'; m = k.match(/^(\d+)\.67$/); if (m) return m[1] + ' 2/3'; return k; },
    parseVariants: parseVariants, bestMatch: bestMatch, sizeKey: sizeKey, sizeGroupsFor: sizeGroupsFor
  };
  root.ShadeFinder = api;
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
})(typeof window !== 'undefined' ? window : globalThis);
